var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step",class:{ active: _vm.active, disabled: _vm.disabled, completed: _vm.completed }},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }